if (!customElements.get('coaching-quiz')) {
  customElements.define(
    'coaching-quiz',
    class CoachingQuiz extends HTMLElement {
      connectedCallback() {
        if (this.dataset.quizInitialized === 'true') return;
        this.dataset.quizInitialized = 'true';

        this.panels = [...this.querySelectorAll('[data-coaching-panel]')];
        this.stepButtons = [...this.querySelectorAll('[data-coaching-step-button]')];
        this.backButton = this.querySelector('[data-coaching-back]');
        this.restartButton = this.querySelector('[data-coaching-restart]');
        this.progress = this.querySelector('[data-coaching-progress]');
        this.results = this.querySelector('[data-coaching-results]');
        this.answers = {};
        this.currentStep = 0;
        this.maxReachedStep = 0;
        this.products = this.readProducts();

        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.addEventListener('change', () => this.handleAnswer(input));
        });

        this.backButton?.addEventListener('click', () => this.showStep(this.currentStep - 1));
        this.restartButton?.addEventListener('click', () => this.restart());
        this.stepButtons.forEach((button) => {
          button.addEventListener('click', () => this.showStep(Number(button.dataset.coachingStepButton)));
        });

        this.showStep(0);
      }

      readProducts() {
        const data = this.querySelector('[data-coaching-products]');
        if (!data) return [];

        try {
          return JSON.parse(data.textContent).map((product, index) => ({
            ...product,
            index,
            normalizedTags: product.tags.map((tag) => tag.toLowerCase().trim()),
          }));
        } catch (error) {
          console.warn('Valmennuskyselyn tuotetietoja ei voitu lukea.', error);
          return [];
        }
      }

      handleAnswer(input) {
        const answerGroup = input.name.split('-')[0];
        this.answers[answerGroup] = input.value;

        window.setTimeout(() => {
          if (this.currentStep === 5) {
            this.renderResults();
            this.showStep(6);
          } else {
            this.showStep(this.currentStep + 1);
          }
        }, 160);
      }

      showStep(step) {
        if (step < 0 || step >= this.panels.length) return;

        this.currentStep = step;
        this.maxReachedStep = Math.max(this.maxReachedStep, step);

        this.panels.forEach((panel, index) => {
          panel.hidden = index !== step;
          panel.classList.toggle('is-active', index === step);
        });

        this.stepButtons.forEach((button, index) => {
          button.classList.toggle('is-active', index === step);
          button.classList.toggle('is-complete', index < step);
          button.disabled = index > this.maxReachedStep;
          button.setAttribute('aria-current', index === step ? 'step' : 'false');
        });

        if (this.progress) {
          this.progress.style.width = `${((step + 1) / this.panels.length) * 100}%`;
        }

        if (this.backButton) this.backButton.hidden = step === 0 || step === 6;
        if (this.restartButton) this.restartButton.hidden = step !== 6;
      }

      hasTag(product, tag) {
        return product.normalizedTags.includes(tag);
      }

      scoreProduct(product) {
        const has = (tag) => this.hasTag(product, tag);
        let score = product.available ? 0 : -1;
        const reasons = [];

        if (has(`quiz_goal_${this.answers.goal}`)) {
          score += 6;
          reasons.push('tavoitteesi');
        }

        const hasGenderTags = product.normalizedTags.some((tag) => tag.startsWith('quiz_gender_'));
        if (
          this.answers.gender === 'kaikki' ||
          has('quiz_gender_kaikki') ||
          has(`quiz_gender_${this.answers.gender}`) ||
          !hasGenderTags
        ) {
          score += 2;
        } else {
          score -= 12;
        }

        if (has(`quiz_age_${this.answers.age}`)) {
          score += 2;
          reasons.push('ikäryhmäsi');
        }

        if (has(`quiz_level_${this.answers.level}`)) {
          score += 4;
          reasons.push('lähtötasosi');
        }

        if (has(`quiz_days_${this.answers.days}`)) {
          score += 4;
          reasons.push('treenimääräsi');
        }

        if (has(`quiz_focus_${this.answers.focus}`)) {
          score += 3;
          reasons.push('toivomasi tuen');
        }

        const priorityTag = product.normalizedTags.find((tag) => /^quiz_priority_\d+$/.test(tag));
        if (priorityTag) score += Number(priorityTag.replace('quiz_priority_', '')) / 100;

        return { ...product, score, reasons };
      }

      renderResults() {
        if (!this.results) return;

        const count = Number(this.dataset.resultCount || 1);
        const ranked = this.products
          .map((product) => this.scoreProduct(product))
          .sort((a, b) => b.score - a.score || a.index - b.index)
          .slice(0, count);

        this.results.innerHTML = '';

        ranked.forEach((product, index) => {
          const sourceCard = this.querySelector(`[data-coaching-product-card="${product.id}"]`);
          if (!sourceCard) return;

          const card = sourceCard.cloneNode(true);
          const label = card.querySelector('[data-coaching-result-label]');
          const reason = card.querySelector('[data-coaching-product-reason]');

          if (label) label.textContent = index === 0 ? 'Sinulle sopivin valmennus' : `${index + 1}. vaihtoehto`;
          if (reason && product.reasons.length) {
            reason.textContent = `Sopii hyvin, koska se vastaa ${product.reasons.join(', ')}.`;
          }

          this.results.appendChild(card);
        });
      }

      restart() {
        this.answers = {};
        this.maxReachedStep = 0;
        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
        });
        this.showStep(0);
      }
    }
  );
}
